<template>
    <div class="checkout-box">
        <div v-if="status">
            <div v-if="status == 'succeeded'" style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e; text-align: center">
                你成功{{ isRenew ? "續訂" : isSubscribe ? "訂閱" : "註冊和訂閱" }}網上學習平台！
                <br />
                Congratulations!
            </div>
            <div v-else style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e; text-align: center; white-space: pre-wrap">
                {{ "付款失敗！\nPayment failed!" }}
            </div>
            <div>
                <p v-if="status == 'succeeded'" style="white-space: pre-wrap; text-align: center; margin-top: 2rem">
                    {{
                        "我們已將" +
                        (isRenew ? "續訂" : isSubscribe ? "訂閱" : "註冊和訂閱") +
                        `確認電子郵件發送至${email}\n交易編號 ${orderNo}` +
                        "\nWe have sent the " +
                        (isRenew ? "renewal subscription" : isSubscribe ? "subscription" : "registration and subscription") +
                        ` confirmation email to ${email}.\nTransaction number ${orderNo}`
                    }}
                </p>
                <!-- <p v-else style="white-space: pre-wrap;text-align:center;margin-top:2rem">{{`我們已傳送了一封電子郵件至 ${email}\n請點擊電郵內的超連結繼續付款，付款連結有效期為一星期。\nWe have sent an email to ${email}.\nPlease click the link in the email to continue with the payment.\n The payment link is valid for one week.`}}</p> -->
            </div>
            <div style="display: flex; flex-direction: column; margin-top: 4rem">
                <el-button v-if="!isRenew && !isSubscribe && status == 'succeeded'" round @click="onLogin" class="security-button">登入家長平台 Log in to the parent platform</el-button>
                <el-button v-if="(!isRenew && !isSubscribe) || status != 'succeeded'" round @click="onHome" class="security-button">返回網頁 Back to website</el-button>
                <el-button v-else round @click="onProfile" class="security-button" style="background-color: #fcc03a">返回家長平台 Back to the parent platform</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import { getProfile } from "@/api/user";
import { getOrderDetail } from "@/api/order";
import { setUserInfo } from "@/utils/auth";
export default {
    data() {
        return {
            registerSuccess: "你成功註冊和訂閱網上學習平台！",
            renewSuccess: "你成功續訂網上學習平台！",
            subscribeSuccess: "你成功訂閱網上學習平台！",
            email: "",
            orderNo: "",
            isRenew: false,
            isSubscribe: false,
            isFail: false,
            status: "",
        };
    },
    watch: {},
    mounted() {},
    created() {
        if (!this.isEmpty(this.$route.query.orderId)) {
            this.getOrderDetail(this.$route.query.orderId);
        }
        if (!this.isEmpty(this.$route.query.isRenew) && this.$route.query.isRenew === "true") {
            this.isRenew = true;
        }
        if (!this.isEmpty(this.$route.query.isSubscribe) && this.$route.query.isSubscribe === "true") {
            this.isSubscribe = true;
        }
        if (!this.isEmpty(this.$route.query.isFail) && this.$route.query.isFail === "true") {
            this.status = "fail";
        }
        if (!this.isEmpty(this.$route.query.status)) {
            this.status = this.$route.query.status;
        }
        setTimeout(() => {
            this.checkStatus();
        }, 1000);
    },
    methods: {
        async checkStatus() {
            if (!this.status) {
                this.stripe = await loadStripe("pk_live_51L0HUaI8vOrdPKKT8Rs8n8B6kq0siShB5AEsP0K7bADZYXYOIBTgwsm7lxfuNJZWyqojDlQmGHo5eko1oX0Ti8BF005s8QX9hn");
                const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");

                if (!clientSecret) {
                    this.status = "fail";
                    return;
                }

                const { paymentIntent, error } = await this.stripe.retrievePaymentIntent(clientSecret);
                if (error) {
                    this.status = "fail";
                } else {
                    switch (paymentIntent.status) {
                        case "succeeded":
                            this.status = "succeeded";
                            break;
                        case "processing":
                            this.status = "processing";
                            break;
                        case "requires_payment_method":
                            this.status = "requires_payment_method";
                            break;
                        default:
                            break;
                    }
                }
            }

            if (this.token) this.getProfile();
        },
        getOrderDetail(id) {
            getOrderDetail(id).then((v) => {
                this.email = v.data.parent.email;
                this.orderNo = v.data.orderNo;
                // this.status=v.data.status==1?'succeeded':'fail'
            });
        },
        getProfile() {
            if (this.status == "succeeded") {
                getProfile().then((v) => {
                    setUserInfo("userProfile", v.data);
                });
            }
        },
        onLogin() {
            this.$router.push({ path: "/login" });
        },
        onHome() {
            this.$router.push({ name: "home" });
        },
        onProfile() {
            this.$router.push({ path: "/parentProfile" });
        },
    },
};
</script>

<style lang="scss" scoped>
.checkout-box {
    position: fixed;
    display: flex;
    top: 4.5rem;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
}
.security-button {
    margin: 1.25rem 0;
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    font-size: 1.125rem;
    color: #444444;
}
.security-button:nth-child(1) {
    background-color: #fcc03a;
}
.security-button:nth-last-child(1) {
    background-color: #ffffff;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .checkout-box {
        margin: 0 1.25rem 2rem;
    }
}
</style>
